import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AuthInterface from './AuthInterface';

const initialState: AuthInterface = {
  user_id: 0,
  emp_id: 0,
  name: '',
  username: '',
  profile_pic: '',
  email: '',
  status: 0,
  company_id: 0,
  department: '',
  designaion: '',
  department_id: 0,
  staff_id: 0,
  hire_date: '',
  currency: '',
  user_session_id: '',
};

const authSlice = createSlice({
  name: 'auth',

  initialState,
  reducers: {
    user_login: (state: any, action: PayloadAction<AuthInterface>) => {
      const payload = action.payload;
      state.user_id = payload.user_id;
      state.name = payload.name;
      state.username = payload.username;
      state.profile_pic = payload.profile_pic;
      state.email = payload.email;
      state.status = payload.status;
      state.company_id = payload.company_id;
      state.department = payload.department;
      state.designaion = payload.designaion;
      state.emp_id = payload.emp_id;
      state.department_id = payload.department_id;
      state.staff_id = payload.staff_id;
      state.hire_date = payload.hire_date;
      state.currency = payload.currency;
    },
    user_session: (state: any, action: any) => {
      const payload = action.payload;
      state.user_session_id = payload;
    },
    user_logout: (state: any) => {
      state.user_id = '';
      state.name = '';
      state.username = '';
      state.profile_pic = '';
      state.email = '';
      state.status = '';
      state.department = '';
      state.designaion = '';
      state.emp_id = '';
      state.department_id = '';
      state.staff_id = 0;
      state.hire_date = '';
      state.currency = '';
      state.user_session_id = '';
    },
  },
});

export const { user_login, user_logout, user_session } = authSlice.actions;

export default authSlice.reducer;
